<script lang="ts">
  export let htmlType: 'code' | 'span' = 'code';
  export let text = '';
</script>

{#if htmlType === 'code'}
  <code contenteditable="false" bind:innerHTML="{text}"></code>
{:else}{#if htmlType === 'span'}
  <span contenteditable="false" bind:innerHTML="{text}"></span>
{/if}{/if}
